<template>
  <ion-phaser ref="ionphaser" v-bind:game.prop="game" v-bind:initialize.prop="initialize" />
</template>
<script>
import Phaser from "phaser";
export default {
  props: {
    Player: {
      id: ""
    },
    OnLevel1Finished: {
      type: Function
    }
  },
  data() {
    return {
      initialize: true,
      game: {
        type: Phaser.AUTO,
        width: 1080,
        height: 1920,
        scale: {
          mode: Phaser.Scale.WIDTH_CONTROLS_HEIGHT
        },
        scene: {
          preload: function() {
            this.load.image(
              "bg",
              require("../assets/2.中繼站1_2/中繼站1_遊戲背景.png")
            );
            this.load.image(
              "title",
              require("../assets/2.中繼站1_2/中繼站1_BONUS TIME.png")
            );
            this.load.image(
              "mask",
              require("../assets/2.中繼站1_2/倒數開始_壓黑.png")
            );
            this.load.image(
              "intro",
              require("../assets/2.中繼站1_2/中繼站1_說明跳窗.png")
            );
            this.load.image(
              "close",
              require("../assets/2.中繼站1_2/中繼站1_X按鈕.png")
            );
            this.load.image(
              "score",
              require("../assets/2.中繼站1_2/中繼站1_數字時間.png")
            );
            this.load.image(
              "blue_bubble",
              require("../assets/2.中繼站1_2/藍泡泡球_0044.png")
            );
            this.load.image(
              "yellow_bubble",
              require("../assets/2.中繼站1_2/灰泡泡球_0044.png")
            );
            this.load.image(
              "purple_bubble",
              require("../assets/2.中繼站1_2/紫泡泡球_0044.png")
            );
            this.load.image(
              "add_score",
              require("../assets/2.中繼站1_2/+1/+1_0010.png")
            );
            this.load.image(
              "sub_score",
              require("../assets/2.中繼站1_2/-1/-1_0010.png")
            );
            this.load.image(
              "timeup",
              require("../assets/2.中繼站1_2/中繼站1_時間到.png")
            );
            this.load.image(
              "result",
              require("../assets/2.中繼站1_2/中繼站1_計算成績.png")
            );
            this.load.bitmapFont(
              "score_font",
              require("../assets/2.中繼站1_2/font/font.png"),
              "./font.fnt"
            );
          },
          init: function() {},
          create: function() {
            var isGaming = true;
            this.registry.values.gametime = 30;
            var fadeDuration = 400;
            this.add.image(0, 0, "bg").setOrigin(0);
            this.title = this.add
              .image(305, 0, "title")
              .setOrigin(0, 0)
              .setVisible(false);
            this.scorebg = this.add
              .image(0, 300, "score")
              .setOrigin(0, 0)
              .setVisible(false);
            var SetScore = score => {
              localScoreText.text =
                String(parseInt(score)).padStart(2, "0") + "s";
            };
            var OnGameStart = () => {
              this.close.setVisible(false);
              this.mask.setVisible(false);
              this.intro.setVisible(false);
              //this.title.setVisible(true);
              this.scorebg.setVisible(true);
              this.timetext.setVisible(true);
              this.scoretext.setVisible(true);
              this.timeTimer.paused = false;
              this.gameTimer.paused = false;
            };
            this.mask = this.add.image(540, 960, "mask").setOrigin(0.5);
            this.intro = this.add
              .image(540, 800, "intro")
              .setOrigin(0.5)
              .setInteractive()
              .on("pointerdown", OnGameStart);
            this.close = this.add
              .image(540, 1080, "close")
              .setOrigin(0.5)
              .setInteractive()
              .on("pointerdown", OnGameStart);

            this.scoretext = this.add
              .bitmapText(
                170,
                390,
                "score_font",
                "00s" /*{
                fontSize: "150px",
                align: "left",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0)
              .setVisible(false);
            var localScoreText = this.scoretext;
            this.timetext = this.add
              .bitmapText(
                690,
                390,
                "score_font",
                this.registry.values
                  .gametime /*{
                fontSize: "150px",
                align: "center",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0)
              .setVisible(false);

            var positions = [
              {
                x: 270,
                y: 1100
              },
              {
                x: 540,
                y: 1100
              },
              {
                x: 810,
                y: 1100
              },
              {
                x: 240,
                y: 1320
              },
              {
                x: 540,
                y: 1320
              },
              {
                x: 840,
                y: 1320
              },
              {
                x: 200,
                y: 1570
              },
              {
                x: 550,
                y: 1570
              },
              {
                x: 890,
                y: 1570
              }
            ];
            var containers = [];
            for (var i = 0; i < positions.length; i++) {
              var addscore = this.add
                .image(positions[i].x, positions[i].y, "add_score")
                .setAlpha(0);
              var subscore = this.add
                .image(positions[i].x, positions[i].y, "sub_score")
                .setAlpha(0);
              var add_score_show = this.tweens.add({
                targets: addscore,
                paused: true,
                props: {
                  alpha: {
                    value: { from: 0, to: 1 },
                    duration: fadeDuration,
                    ease: "Linear",
                    yoyo: true
                  },
                  y: { value: "-=100", duration: 300, ease: "Cubic" }
                },
                ease: "Linear",
                repeat: 0
              });
              var sub_score_show = this.tweens.add({
                targets: subscore,
                paused: true,
                props: {
                  alpha: {
                    value: { from: 0, to: 1 },
                    duration: fadeDuration,
                    ease: "Linear",
                    yoyo: true
                  },
                  y: { value: "-=100", duration: 300, ease: "Cubic" }
                },
                repeat: 0
              });
              var blue = this.add
                .image(positions[i].x, positions[i].y, "blue_bubble")
                .setInteractive();
              blue.on(
                "pointerdown",
                (function() {
                  var btn = blue;
                  var add = add_score_show;
                  return function() {
                    if (!isGaming) return;
                    add.targets[0].setVisible(true);
                    add.play();
                    btn.setVisible(false);
                    btn.alpha = 0;
                    score++;
                    if (score > 99) score = 99;
                    SetScore(score);
                  };
                })()
              );

              var blue_fadein = this.tweens.add({
                targets: blue,
                alpha: { from: 0, to: 1 },
                scale: { from: 0, to: 1 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });
              var blue_fadeout = this.tweens.add({
                targets: blue,
                alpha: { from: 1, to: 0 },
                scale: { from: 1, to: 0 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });

              var yellow = this.add
                .image(positions[i].x, positions[i].y, "yellow_bubble")
                .setInteractive();
              yellow.on(
                "pointerdown",
                (function() {
                  var btn = yellow;
                  var sub = sub_score_show;
                  return function() {
                    if (!isGaming) return;
                    sub.targets[0].setVisible(true);
                    btn.setVisible(false);
                    btn.alpha = 0;
                    sub.play();
                    if (score > 0) score--;
                    SetScore(score);
                  };
                })()
              );
              var yellow_fadein = this.tweens.add({
                targets: yellow,
                alpha: { from: 0, to: 1 },
                scale: { from: 0, to: 1 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });
              var yellow_fadeout = this.tweens.add({
                targets: yellow,
                alpha: { from: 1, to: 0 },
                scale: { from: 1, to: 0 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });

              var purple = this.add
                .image(positions[i].x, positions[i].y, "purple_bubble")
                .setInteractive();
              purple.on(
                "pointerdown",
                (function() {
                  var btn = purple;
                  var sub = sub_score_show;
                  return function() {
                    if (!isGaming) return;
                    sub.targets[0].setVisible(true);
                    btn.setVisible(false);
                    btn.alpha = 0;
                    sub.play();
                    if (score > 0) score--;
                    SetScore(score);
                  };
                })()
              );
              var purple_fadein = this.tweens.add({
                targets: purple,
                alpha: { from: 0, to: 1 },
                scale: { from: 0, to: 1 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });
              var purple_fadeout = this.tweens.add({
                targets: purple,
                alpha: { from: 1, to: 0 },
                scale: { from: 1, to: 0 },
                ease: "Linear",
                duration: fadeDuration,
                repeat: 0,
                paused: true,
                yoyo: false
              });

              blue.setVisible(false);
              blue.setAlpha(0);
              yellow.setVisible(false);
              yellow.setAlpha(0);
              purple.setVisible(false);
              purple.setAlpha(0);
              addscore.setVisible(false);
              subscore.setVisible(false);
              containers.push({
                bubbles: [blue, yellow, purple],
                fadeins: [blue_fadein, yellow_fadein, purple_fadein],
                fadeouts: [blue_fadeout, yellow_fadeout, purple_fadeout]
              });
            }
            var count = 0;
            var score = 0;
            this.timeTimer = this.time.addEvent({
              delay: 1000,
              callback: () => {
                this.registry.values.gametime--;
                this.timetext.text = String(
                  this.registry.values.gametime
                ).padStart(2, "0");
                if (this.registry.values.gametime <= 0) {
                  isGaming = false;
                  this.time.addEvent({
                    delay: 1000,
                    callback: () => {
                      this.resultBigScoretext.text = this.resultScoreText.text = this.resultCountText.text = String(
                        score
                      );
                      this.resultBigScoretext.text += "s";
                      this.scorebg.setVisible(false);
                      this.timetext.setVisible(false);
                      this.scoretext.setVisible(false);
                      this.showResult.play();
                      this.showResultText.play();
                      this.showTimeup.play();
                      this.time.addEvent({
                        delay: 2500,
                        callback: () => {
                          this.registry.values.onGameEnded(score);
                        }
                      });
                    }
                  });
                }
              },
              repeat: this.registry.values.gametime - 1,
              paused: true
            });
            this.gameTimer = this.time.addEvent({
              delay: 100,
              callback: () => {
                if (!isGaming) return;
                count++;
                var index = Phaser.Math.RND.integerInRange(
                  0,
                  positions.length - 1
                );
                var isFadeOuting = false;
                for (var i = 0; i < containers[index].bubbles.length; i++) {
                  if (containers[index].bubbles[i].alpha != 0) {
                    isFadeOuting = true;
                  }
                }
                if (!isFadeOuting) {
                  var bubbleIndex = Phaser.Math.RND.integerInRange(
                    0,
                    containers[index].bubbles.length - 1
                  );
                  containers[index].bubbles[bubbleIndex].setVisible(true);
                  containers[index].fadeins[bubbleIndex].play();
                  var delay = Phaser.Math.RND.integerInRange(
                    1000 + fadeDuration,
                    3000 + fadeDuration
                  );
                  delay -= count * 3;
                  if (delay < 500) delay = 500;
                  this.time.addEvent({
                    delay: delay,
                    callback: () => {
                      containers[index].fadeouts[bubbleIndex].play();
                    }
                  });
                }
              },
              callbackScope: this,
              loop: true,
              paused: true
            });

            this.timeup = this.add.image(550, 250, "timeup").setOrigin(0.5);
            this.timeup.scale = 0;
            this.showTimeup = this.tweens.add({
              targets: this.timeup,
              scale: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
            var result = this.add.image(540, 800, "result").setOrigin(0.5);
            result.scale = 0;

            this.resultCountText = this.add
              .text(570, 610, "0", { fontSize: "55px", align: "left" })
              .setColor("#000")
              .setOrigin(0.5)
              .setAlpha(0);
            this.resultScoreText = this.add
              .text(515, 680, "0", { fontSize: "55px", align: "left" })
              .setColor("#000")
              .setOrigin(0.5)
              .setAlpha(0);
            this.resultBigScoretext = this.add
              .bitmapText(
                525,
                880,
                "score_font",
                "0S" /*{
                fontSize: "200px",
                align: "center",
                stroke: "#000",
                strokeThickness: 10
              }*/
              )
              .setOrigin(0.5)
              .setAlpha(0);
            this.showResult = this.tweens.add({
              targets: result,
              scale: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
            this.showResultText = this.tweens.add({
              targets: [
                this.resultCountText,
                this.resultScoreText,
                this.resultBigScoretext
              ],
              alpha: { from: 0, to: 1 },
              ease: "Linear",
              duration: 300,
              delay: 300,
              repeat: 0,
              yoyo: false,
              paused: true
            });
          },
          update: function() {}
        }
      }
    };
  },
  computed: {
    data: function() {
      return this.$refs.ionphaser.game.instance.registry.values;
    }
  },
  async mounted() {
    await this.Delay(500);
    this.data.onGameEnded = score => {
      if (this.OnLevel1Finished) {
        this.OnLevel1Finished(parseInt(score));
      }
    };
  },
  methods: {
    Delay(interval) {
      return new Promise(resolve => {
        setTimeout(resolve, interval);
      });
    }
  }
};
</script>
